<template>
  <div>
    <div v-if="table_tooltip"></div>
    <div v-else>
      <div v-if="!mobile_check" class="tooltip" style="margin-top:5px;">
        <img src="@/assets/info.png" style="height: 36px; width: 36px;" />
        <span class="tooltiptext-big" v-if="text == 'test'">
          <ul>
            <li>
              {{ $t("message.clickOn") }}
              <v-icon
                small
                :title="$t('message.viewLabel')"
                color="#027953"
                class="mr-2"
              >
                visibility
              </v-icon>
              {{ $t("message.toSeeFile") }}
            </li>
            <li>
              {{ $t("message.clickOn") }}
              <v-icon
                small
                :title="$t('message.downloadLabel')"
                color="#027953"
                class="mr-2"
              >
                cloud_download
              </v-icon>
              {{ $t("message.toDownloadFile") }}
            </li>
            <li>
              {{ $t("message.clickOn") }}
              <v-icon
                small
                :title="$t('message.sendLabel')"
                color="#027953"
                class="mr-2"
              >
                send
              </v-icon>
              {{ $t("message.toReply") }}
            </li>
          </ul>
        </span>
      </div>
      <div v-else class="tooltip" style="margin-top:5px;">
        <img
          src="@/assets/info.png"
          style="height: 36px; width: 36px;"
          @click="openTipsDialog"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tooltip",
  props: ["table_tooltip", "mobile_check", "text"],
  methods: {
    openTipsDialog: function() {
      this.$emit("showStateDialog", true);
    }
  }
};
</script>
<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: white;
  color: #027953;
  border-style: solid;
  border-width: 2px;
  text-align: center;
  border-radius: 6px;
  padding: 5px 2px;
  word-wrap: break-word;
  white-space: normal;
  margin-top: 30px;
  margin-left: -150px;

  /* Position the tooltip */
  position: fixed;
  z-index: 1000;
}
.tooltip .tooltiptext-big {
  visibility: hidden;
  width: 300px;
  background-color: white;
  color: #027953;
  border-style: solid;
  border-width: 2px;
  text-align: left;
  border-radius: 6px;
  padding: 5px 2px;
  word-wrap: break-word;
  white-space: normal;

  /* Position the tooltip */
  margin-top: 40px;
  margin-left: -115px;
  position: fixed;
  z-index: 1000;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip:hover .tooltiptext-big {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/tooltip/Tooltip.vue